
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.6.0
 * Query Engine version: f676762280b54cd07c770017ed3711ddde35f37a
 */
Prisma.prismaVersion = {
  client: "6.6.0",
  engine: "f676762280b54cd07c770017ed3711ddde35f37a"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  name: 'name',
  password: 'password',
  email: 'email',
  emailValidated: 'emailValidated',
  onboardedAt: 'onboardedAt',
  signupChannel: 'signupChannel',
  addonFirstSeenAt: 'addonFirstSeenAt',
  image: 'image',
  system: 'system',
  mobile: 'mobile',
  adminRoleId: 'adminRoleId',
  emailVerified: 'emailVerified'
};

exports.Prisma.ProfileScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  info: 'info',
  organization: 'organization',
  uid: 'uid'
};

exports.Prisma.ApiKeyScalarFieldEnum = {
  id: 'id',
  key: 'key',
  valid: 'valid',
  metaData: 'metaData',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  userId: 'userId'
};

exports.Prisma.LicenseFileScalarFieldEnum = {
  id: 'id',
  fileUrl: 'fileUrl',
  validityPeriod: 'validityPeriod',
  licenseType: 'licenseType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  apiKeyId: 'apiKeyId'
};

exports.Prisma.BareunAppScalarFieldEnum = {
  id: 'id',
  appId: 'appId',
  name: 'name',
  description: 'description',
  serviceUrl: 'serviceUrl',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId'
};

exports.Prisma.UserAccountScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
};

exports.Prisma.AdminRoleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  description: 'description',
  readOnly: 'readOnly',
  permissions: 'permissions'
};

exports.Prisma.ApiUsageScalarFieldEnum = {
  id: 'id',
  apiKeyId: 'apiKeyId',
  userId: 'userId',
  timestamp: 'timestamp',
  endpoint: 'endpoint',
  callCount: 'callCount',
  wordCount: 'wordCount',
  features: 'features',
  isCloud: 'isCloud',
  eojeolCount: 'eojeolCount',
  bareunId: 'bareunId',
  usagePeriodId: 'usagePeriodId',
  deductionSource: 'deductionSource'
};

exports.Prisma.ErrorLogScalarFieldEnum = {
  id: 'id',
  apiKeyId: 'apiKeyId',
  userId: 'userId',
  timestamp: 'timestamp',
  error: 'error',
  bareunId: 'bareunId',
  reviewedAt: 'reviewedAt',
  bodyPurgedAt: 'bodyPurgedAt'
};

exports.Prisma.PanicIssueScalarFieldEnum = {
  id: 'id',
  fingerprint: 'fingerprint',
  kind: 'kind',
  frames: 'frames',
  gitlabIssueIid: 'gitlabIssueIid',
  count: 'count',
  firstSeenAt: 'firstSeenAt',
  lastSeenAt: 'lastSeenAt',
  firstVersion: 'firstVersion',
  firstBundle: 'firstBundle',
  lastVersion: 'lastVersion',
  lastBundle: 'lastBundle',
  sampleDetails: 'sampleDetails',
  sampleFunc: 'sampleFunc',
  sampleAgent: 'sampleAgent',
  reporterEmail: 'reporterEmail'
};

exports.Prisma.RegisteredScalarFieldEnum = {
  id: 'id',
  apiKeyId: 'apiKeyId',
  userId: 'userId',
  timestamp: 'timestamp',
  isDeleted: 'isDeleted',
  bareunId: 'bareunId',
  log: 'log'
};

exports.Prisma.BareunUsageLogScalarFieldEnum = {
  id: 'id',
  apiKeyId: 'apiKeyId',
  userId: 'userId',
  timestamp: 'timestamp',
  log: 'log',
  bareunId: 'bareunId',
  appId: 'appId',
  usedEpoch: 'usedEpoch',
  ua: 'ua',
  akey: 'akey',
  totalCalls: 'totalCalls',
  totalSentences: 'totalSentences',
  totalTokens: 'totalTokens',
  analyzeCalls: 'analyzeCalls',
  analyzeSentences: 'analyzeSentences',
  tokenizeCalls: 'tokenizeCalls',
  tokenizeSentences: 'tokenizeSentences',
  correctErrorCalls: 'correctErrorCalls',
  correctErrorSentences: 'correctErrorSentences',
  analyzeListCalls: 'analyzeListCalls',
  analyzeListSentences: 'analyzeListSentences'
};

exports.Prisma.FaqPageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  name: 'name',
  description: 'description',
  url: 'url',
  inLanguage: 'inLanguage',
  dateModified: 'dateModified',
  publisherName: 'publisherName',
  publisherUrl: 'publisherUrl',
  published: 'published'
};

exports.Prisma.FaqCategoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  description: 'description',
  order: 'order'
};

exports.Prisma.FaqQuestionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  name: 'name',
  answerText: 'answerText',
  categoryId: 'categoryId',
  faqPageId: 'faqPageId',
  order: 'order',
  published: 'published',
  viewCount: 'viewCount',
  userId: 'userId',
  attachments: 'attachments',
  tags: 'tags',
  slug: 'slug'
};

exports.Prisma.BannerMessageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  content: 'content',
  published: 'published',
  priority: 'priority',
  startedAt: 'startedAt',
  endedAt: 'endedAt',
  userId: 'userId'
};

exports.Prisma.UserNoticeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  publish: 'publish',
  subject: 'subject',
  content: 'content',
  filepath: 'filepath',
  startedAt: 'startedAt',
  endedAt: 'endedAt',
  userId: 'userId'
};

exports.Prisma.AuditLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  action: 'action',
  entityId: 'entityId',
  previousData: 'previousData',
  newData: 'newData',
  category: 'category',
  level: 'level',
  description: 'description',
  userId: 'userId'
};

exports.Prisma.SubscriptionPlanScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  slug: 'slug',
  description: 'description',
  priceKRW: 'priceKRW',
  annualPriceKRW: 'annualPriceKRW',
  eojeolQuota: 'eojeolQuota',
  overageUnitPrice: 'overageUnitPrice',
  rateLimitPerSec: 'rateLimitPerSec',
  maxTextLength: 'maxTextLength',
  maxDevices: 'maxDevices',
  maxFileSizeMB: 'maxFileSizeMB',
  maxCustomDicts: 'maxCustomDicts',
  features: 'features',
  isActive: 'isActive',
  displayOrder: 'displayOrder'
};

exports.Prisma.SubscriptionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  planId: 'planId',
  status: 'status',
  billingCycle: 'billingCycle',
  currentPeriodStart: 'currentPeriodStart',
  currentPeriodEnd: 'currentPeriodEnd',
  canceledAt: 'canceledAt',
  cancelReason: 'cancelReason',
  trialEndsAt: 'trialEndsAt',
  billingKeyId: 'billingKeyId',
  scheduledPlanId: 'scheduledPlanId',
  customEojeolQuota: 'customEojeolQuota',
  metadata: 'metadata'
};

exports.Prisma.SubscriptionEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  subscriptionId: 'subscriptionId',
  eventType: 'eventType',
  fromStatus: 'fromStatus',
  toStatus: 'toStatus',
  fromPlanId: 'fromPlanId',
  toPlanId: 'toPlanId',
  paymentId: 'paymentId',
  amountKRW: 'amountKRW',
  reason: 'reason',
  metadata: 'metadata',
  actorId: 'actorId'
};

exports.Prisma.UsagePeriodScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  subscriptionId: 'subscriptionId',
  periodStart: 'periodStart',
  periodEnd: 'periodEnd',
  eojeolQuota: 'eojeolQuota',
  eojeolUsed: 'eojeolUsed',
  eojeolExtra: 'eojeolExtra',
  overageEojeol: 'overageEojeol',
  overageBilled: 'overageBilled'
};

exports.Prisma.EojeolPackageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  priceKRW: 'priceKRW',
  eojeolAmount: 'eojeolAmount',
  isActive: 'isActive',
  displayOrder: 'displayOrder'
};

exports.Prisma.BillingKeyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  provider: 'provider',
  billingKey: 'billingKey',
  status: 'status',
  cardMeta: 'cardMeta',
  isDefault: 'isDefault',
  activatedAt: 'activatedAt',
  deactivatedAt: 'deactivatedAt',
  deactivateReason: 'deactivateReason'
};

exports.Prisma.PaymentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  subscriptionId: 'subscriptionId',
  billingKeyId: 'billingKeyId',
  type: 'type',
  status: 'status',
  amountKRW: 'amountKRW',
  provider: 'provider',
  method: 'method',
  tossOrderId: 'tossOrderId',
  tossPaymentKey: 'tossPaymentKey',
  approvedAt: 'approvedAt',
  canceledAt: 'canceledAt',
  failureCode: 'failureCode',
  failureMessage: 'failureMessage',
  rawPayload: 'rawPayload',
  metadata: 'metadata',
  idempotencyKey: 'idempotencyKey',
  eojeolAmount: 'eojeolAmount'
};

exports.Prisma.PaymentWebhookEventScalarFieldEnum = {
  id: 'id',
  receivedAt: 'receivedAt',
  provider: 'provider',
  eventType: 'eventType',
  signature: 'signature',
  payload: 'payload',
  processed: 'processed',
  processedAt: 'processedAt',
  error: 'error',
  paymentKey: 'paymentKey',
  orderId: 'orderId'
};

exports.Prisma.DocReactionStateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  path: 'path',
  anonymousId: 'anonymousId',
  reaction: 'reaction',
  title: 'title',
  version: 'version'
};

exports.Prisma.DocOpinionEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  path: 'path',
  opinion: 'opinion',
  anonymousId: 'anonymousId',
  ipHash: 'ipHash',
  fingerprint: 'fingerprint',
  userAgent: 'userAgent',
  locale: 'locale',
  referrer: 'referrer',
  isHidden: 'isHidden',
  tags: 'tags',
  title: 'title',
  version: 'version',
  status: 'status',
  processedAt: 'processedAt',
  processedById: 'processedById',
  processedNote: 'processedNote'
};

exports.Prisma.ErrorNotificationLogScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  errorType: 'errorType',
  sentAt: 'sentAt',
  email: 'email',
  metadata: 'metadata'
};

exports.Prisma.QaCategoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  description: 'description',
  slug: 'slug',
  order: 'order',
  icon: 'icon',
  color: 'color',
  parentId: 'parentId'
};

exports.Prisma.QaQuestionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  name: 'name',
  text: 'text',
  authorId: 'authorId',
  categoryId: 'categoryId',
  acceptedAnswerId: 'acceptedAnswerId',
  slug: 'slug',
  viewCount: 'viewCount',
  answerCount: 'answerCount',
  upvoteCount: 'upvoteCount',
  published: 'published',
  publishAt: 'publishAt',
  pinned: 'pinned',
  locked: 'locked',
  tags: 'tags',
  subTags: 'subTags',
  ruleTags: 'ruleTags',
  summary: 'summary',
  sourceTitle: 'sourceTitle',
  sourceUrl: 'sourceUrl',
  attachments: 'attachments'
};

exports.Prisma.QaAnswerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  text: 'text',
  aiModel: 'aiModel',
  reviewNote: 'reviewNote',
  needsRevision: 'needsRevision',
  authorId: 'authorId',
  questionId: 'questionId',
  upvoteCount: 'upvoteCount',
  attachments: 'attachments'
};

exports.Prisma.QaCommentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  text: 'text',
  authorId: 'authorId',
  questionId: 'questionId',
  answerId: 'answerId',
  parentId: 'parentId'
};

exports.Prisma.QaVoteScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  userId: 'userId',
  questionId: 'questionId',
  answerId: 'answerId',
  value: 'value'
};

exports.Prisma.QaExampleGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  questionId: 'questionId',
  type: 'type',
  title: 'title',
  description: 'description',
  order: 'order'
};

exports.Prisma.QaExampleScalarFieldEnum = {
  id: 'id',
  groupId: 'groupId',
  word: 'word',
  label: 'label',
  note: 'note',
  order: 'order'
};

exports.Prisma.QaRelatedQuestionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  questionId: 'questionId',
  relatedId: 'relatedId',
  label: 'label',
  order: 'order'
};

exports.Prisma.OntConceptScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  label: 'label',
  description: 'description',
  slug: 'slug',
  level: 'level',
  icon: 'icon',
  color: 'color',
  parentId: 'parentId'
};

exports.Prisma.OntAliasScalarFieldEnum = {
  id: 'id',
  alias: 'alias',
  conceptId: 'conceptId'
};

exports.Prisma.OntEdgeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  fromId: 'fromId',
  toId: 'toId',
  type: 'type',
  weight: 'weight',
  description: 'description'
};

exports.Prisma.QuestionConceptScalarFieldEnum = {
  id: 'id',
  questionId: 'questionId',
  conceptId: 'conceptId',
  role: 'role',
  relevance: 'relevance'
};

exports.Prisma.EojeolBalanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  balance: 'balance',
  totalCharged: 'totalCharged',
  totalUsed: 'totalUsed',
  totalRefunded: 'totalRefunded'
};

exports.Prisma.EojeolTransactionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  eojeolBalanceId: 'eojeolBalanceId',
  type: 'type',
  amount: 'amount',
  balanceAfter: 'balanceAfter',
  paymentId: 'paymentId',
  reason: 'reason',
  metadata: 'metadata'
};

exports.Prisma.AnonymousUsageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  ipAddress: 'ipAddress',
  date: 'date',
  callCount: 'callCount',
  endpoint: 'endpoint'
};

exports.Prisma.DownloadLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  kind: 'kind',
  version: 'version',
  os: 'os',
  architecture: 'architecture',
  extension: 'extension',
  userId: 'userId',
  ipHash: 'ipHash',
  userAgent: 'userAgent',
  referer: 'referer'
};

exports.Prisma.SpellerReportScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  ipHash: 'ipHash',
  userAgent: 'userAgent',
  originText: 'originText',
  revisedText: 'revisedText',
  category: 'category',
  helpId: 'helpId',
  payload: 'payload',
  content: 'content',
  gitlabIssueIid: 'gitlabIssueIid',
  gitlabIssueUrl: 'gitlabIssueUrl',
  gitlabIssueState: 'gitlabIssueState',
  gitlabSyncedAt: 'gitlabSyncedAt',
  status: 'status',
  processedAt: 'processedAt',
  processedById: 'processedById',
  processedNote: 'processedNote',
  reviewedAt: 'reviewedAt',
  bodyPurgedAt: 'bodyPurgedAt'
};

exports.Prisma.SiteReviewScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  page: 'page',
  score: 'score',
  text: 'text',
  reportOrigin: 'reportOrigin',
  reportRevised: 'reportRevised',
  reportNote: 'reportNote',
  anonymousId: 'anonymousId',
  userId: 'userId',
  ipHash: 'ipHash',
  userAgent: 'userAgent',
  visibility: 'visibility',
  reportPurgedAt: 'reportPurgedAt'
};

exports.Prisma.PushSubscriptionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  endpoint: 'endpoint',
  p256dh: 'p256dh',
  auth: 'auth',
  userAgent: 'userAgent',
  lastSeenAt: 'lastSeenAt',
  failedAt: 'failedAt',
  failureCount: 'failureCount'
};

exports.Prisma.NotificationPreferenceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  category: 'category',
  enabled: 'enabled'
};

exports.Prisma.PushDeliveryLogScalarFieldEnum = {
  id: 'id',
  subscriberKey: 'subscriberKey',
  userId: 'userId',
  category: 'category',
  dedupeKey: 'dedupeKey',
  title: 'title',
  body: 'body',
  url: 'url',
  sentAt: 'sentAt',
  attempted: 'attempted',
  succeeded: 'succeeded',
  failed: 'failed',
  clickedAt: 'clickedAt',
  metadata: 'metadata'
};

exports.Prisma.PublicStatsSnapshotScalarFieldEnum = {
  id: 'id',
  totalCalls: 'totalCalls',
  totalSentences: 'totalSentences',
  totalTokens: 'totalTokens',
  totalInstalls: 'totalInstalls',
  computedAt: 'computedAt',
  durationMs: 'durationMs'
};

exports.Prisma.ResearchApplicationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  organization: 'organization',
  department: 'department',
  role: 'role',
  advisorName: 'advisorName',
  advisorEmail: 'advisorEmail',
  contactEmail: 'contactEmail',
  title: 'title',
  purpose: 'purpose',
  usagePlan: 'usagePlan',
  expectedEojeol: 'expectedEojeol',
  desiredMonths: 'desiredMonths',
  disclosurePlan: 'disclosurePlan',
  gitlabIssueIid: 'gitlabIssueIid',
  gitlabIssueUrl: 'gitlabIssueUrl',
  gitlabIssueState: 'gitlabIssueState',
  gitlabSyncedAt: 'gitlabSyncedAt',
  status: 'status',
  reviewedAt: 'reviewedAt',
  reviewedById: 'reviewedById',
  reviewNote: 'reviewNote',
  grantedFrom: 'grantedFrom',
  grantedUntil: 'grantedUntil',
  grantedEojeolQuota: 'grantedEojeolQuota',
  subscriptionId: 'subscriptionId'
};

exports.Prisma.AddonUserSettingScalarFieldEnum = {
  userId: 'userId',
  settings: 'settings',
  updatedAt: 'updatedAt'
};

exports.Prisma.AddonProfileScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  name: 'name',
  settings: 'settings',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastUsedAt: 'lastUsedAt'
};

exports.Prisma.AddonDailyStatScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  date: 'date',
  action: 'action',
  count: 'count',
  addonVersion: 'addonVersion',
  hwpVersion: 'hwpVersion'
};

exports.Prisma.NoticeMailDeliveryScalarFieldEnum = {
  id: 'id',
  campaign: 'campaign',
  userId: 'userId',
  email: 'email',
  status: 'status',
  attempts: 'attempts',
  lastError: 'lastError',
  sentAt: 'sentAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.SignupChannel = exports.$Enums.SignupChannel = {
  WEB: 'WEB',
  HANCOM_ADDON: 'HANCOM_ADDON'
};

exports.ApiLicense = exports.$Enums.ApiLicense = {
  MORPH_SINGLE: 'MORPH_SINGLE',
  MORPH_MULTI: 'MORPH_MULTI',
  MORPH_MULTI_PLUS: 'MORPH_MULTI_PLUS',
  MORPH_PERPETUAL: 'MORPH_PERPETUAL',
  SPELL_SINGLE: 'SPELL_SINGLE',
  SPELL_MULTI: 'SPELL_MULTI',
  SPELL_MULTI_PLUS: 'SPELL_MULTI_PLUS',
  SPELL_PERPETUAL: 'SPELL_PERPETUAL'
};

exports.BareunAppStatus = exports.$Enums.BareunAppStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};

exports.AdminPermission = exports.$Enums.AdminPermission = {
  ADMIN_READER: 'ADMIN_READER',
  ADMIN_WRITER: 'ADMIN_WRITER',
  ADMIN_ROLE_READER: 'ADMIN_ROLE_READER',
  ADMIN_ROLE_WRITER: 'ADMIN_ROLE_WRITER',
  USER_ROLE_API: 'USER_ROLE_API'
};

exports.ApiFeature = exports.$Enums.ApiFeature = {
  PROOFREADER: 'PROOFREADER',
  MORPH_ANALYZER: 'MORPH_ANALYZER'
};

exports.DeductionSource = exports.$Enums.DeductionSource = {
  SUBSCRIPTION: 'SUBSCRIPTION',
  ONETIME: 'ONETIME',
  FREE: 'FREE',
  NONE: 'NONE'
};

exports.LogLevel = exports.$Enums.LogLevel = {
  DEBUG: 'DEBUG',
  INFO: 'INFO',
  WARN: 'WARN',
  ERROR: 'ERROR'
};

exports.SubscriptionStatus = exports.$Enums.SubscriptionStatus = {
  TRIALING: 'TRIALING',
  ACTIVE: 'ACTIVE',
  PAST_DUE: 'PAST_DUE',
  CANCELED: 'CANCELED',
  EXPIRED: 'EXPIRED'
};

exports.BillingCycle = exports.$Enums.BillingCycle = {
  MONTHLY: 'MONTHLY',
  ANNUAL: 'ANNUAL'
};

exports.SubscriptionEventType = exports.$Enums.SubscriptionEventType = {
  CREATED: 'CREATED',
  TRIAL_STARTED: 'TRIAL_STARTED',
  TRIAL_CONVERTED: 'TRIAL_CONVERTED',
  TRIAL_CANCELED: 'TRIAL_CANCELED',
  UPGRADED: 'UPGRADED',
  DOWNGRADE_SCHEDULED: 'DOWNGRADE_SCHEDULED',
  DOWNGRADE_APPLIED: 'DOWNGRADE_APPLIED',
  DOWNGRADE_CANCELED: 'DOWNGRADE_CANCELED',
  CANCELED: 'CANCELED',
  REACTIVATED: 'REACTIVATED',
  RENEWED: 'RENEWED',
  RENEWAL_FAILED: 'RENEWAL_FAILED',
  EXPIRED: 'EXPIRED',
  PLAN_CHANGED: 'PLAN_CHANGED',
  QUOTA_OVERRIDE_CHANGED: 'QUOTA_OVERRIDE_CHANGED',
  EOJEOL_TOPUP: 'EOJEOL_TOPUP',
  OVERAGE_BILLED: 'OVERAGE_BILLED',
  REFUNDED: 'REFUNDED',
  FREE_ASSIGNED: 'FREE_ASSIGNED',
  FREE_RENEWED: 'FREE_RENEWED'
};

exports.PaymentProvider = exports.$Enums.PaymentProvider = {
  TOSS: 'TOSS'
};

exports.BillingKeyStatus = exports.$Enums.BillingKeyStatus = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  REVOKED: 'REVOKED'
};

exports.PaymentType = exports.$Enums.PaymentType = {
  SUBSCRIPTION: 'SUBSCRIPTION',
  EOJEOL_TOPUP: 'EOJEOL_TOPUP',
  OVERAGE: 'OVERAGE',
  PLAN_CHANGE: 'PLAN_CHANGE',
  REFUND: 'REFUND'
};

exports.PaymentStatus = exports.$Enums.PaymentStatus = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  FAILED: 'FAILED',
  CANCELED: 'CANCELED',
  REFUNDED: 'REFUNDED'
};

exports.PaymentMethod = exports.$Enums.PaymentMethod = {
  CARD: 'CARD',
  VBANK: 'VBANK',
  TRANSFER: 'TRANSFER',
  UNKNOWN: 'UNKNOWN'
};

exports.ReactionType = exports.$Enums.ReactionType = {
  LIKE: 'LIKE',
  DISLIKE: 'DISLIKE'
};

exports.OpinionStatus = exports.$Enums.OpinionStatus = {
  NEW: 'NEW',
  IN_REVIEW: 'IN_REVIEW',
  RESOLVED: 'RESOLVED',
  REJECTED: 'REJECTED'
};

exports.QaVoteType = exports.$Enums.QaVoteType = {
  UP: 'UP',
  DOWN: 'DOWN'
};

exports.QaExampleType = exports.$Enums.QaExampleType = {
  SIMILAR: 'SIMILAR',
  CAUTION: 'CAUTION',
  OPPOSITE: 'OPPOSITE',
  RELATED: 'RELATED'
};

exports.OntLevel = exports.$Enums.OntLevel = {
  ROOT: 'ROOT',
  DOMAIN: 'DOMAIN',
  AREA: 'AREA',
  TOPIC: 'TOPIC',
  DETAIL: 'DETAIL'
};

exports.OntEdgeType = exports.$Enums.OntEdgeType = {
  RELATED: 'RELATED',
  REQUIRES: 'REQUIRES',
  CONTRASTS: 'CONTRASTS',
  CAUSES: 'CAUSES',
  GOVERNED_BY: 'GOVERNED_BY',
  SIMILAR: 'SIMILAR',
  PART_OF: 'PART_OF',
  EXEMPLIFIED_BY: 'EXEMPLIFIED_BY'
};

exports.OntLinkRole = exports.$Enums.OntLinkRole = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
  MENTIONED: 'MENTIONED'
};

exports.EojeolTransactionType = exports.$Enums.EojeolTransactionType = {
  CHARGE: 'CHARGE',
  DEDUCTION: 'DEDUCTION',
  REFUND: 'REFUND',
  ADMIN_ADJUST: 'ADMIN_ADJUST'
};

exports.SpellerReportStatus = exports.$Enums.SpellerReportStatus = {
  NEW: 'NEW',
  IN_REVIEW: 'IN_REVIEW',
  RESOLVED: 'RESOLVED',
  REJECTED: 'REJECTED'
};

exports.SiteReviewVisibility = exports.$Enums.SiteReviewVisibility = {
  COUNTED: 'COUNTED',
  PUBLIC: 'PUBLIC',
  HIDDEN: 'HIDDEN'
};

exports.NotificationCategory = exports.$Enums.NotificationCategory = {
  SPELLER_REPORT: 'SPELLER_REPORT',
  PAYMENT: 'PAYMENT',
  USAGE_LIMIT: 'USAGE_LIMIT',
  PRODUCT_NOTICE: 'PRODUCT_NOTICE',
  DOC_UPDATE: 'DOC_UPDATE',
  ERROR_REPORT: 'ERROR_REPORT',
  SYSTEM: 'SYSTEM'
};

exports.ResearchApplicantRole = exports.$Enums.ResearchApplicantRole = {
  PROFESSOR: 'PROFESSOR',
  RESEARCHER: 'RESEARCHER',
  GRADUATE: 'GRADUATE',
  UNDERGRADUATE: 'UNDERGRADUATE',
  OTHER: 'OTHER'
};

exports.ResearchApplicationStatus = exports.$Enums.ResearchApplicationStatus = {
  PENDING: 'PENDING',
  IN_REVIEW: 'IN_REVIEW',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED',
  REVOKED: 'REVOKED'
};

exports.NoticeMailStatus = exports.$Enums.NoticeMailStatus = {
  PENDING: 'PENDING',
  SENT: 'SENT',
  FAILED: 'FAILED'
};

exports.Prisma.ModelName = {
  User: 'User',
  Profile: 'Profile',
  ApiKey: 'ApiKey',
  LicenseFile: 'LicenseFile',
  BareunApp: 'BareunApp',
  UserAccount: 'UserAccount',
  AdminRole: 'AdminRole',
  ApiUsage: 'ApiUsage',
  ErrorLog: 'ErrorLog',
  PanicIssue: 'PanicIssue',
  Registered: 'Registered',
  BareunUsageLog: 'BareunUsageLog',
  FaqPage: 'FaqPage',
  FaqCategory: 'FaqCategory',
  FaqQuestion: 'FaqQuestion',
  BannerMessage: 'BannerMessage',
  UserNotice: 'UserNotice',
  AuditLog: 'AuditLog',
  SubscriptionPlan: 'SubscriptionPlan',
  Subscription: 'Subscription',
  SubscriptionEvent: 'SubscriptionEvent',
  UsagePeriod: 'UsagePeriod',
  EojeolPackage: 'EojeolPackage',
  BillingKey: 'BillingKey',
  Payment: 'Payment',
  PaymentWebhookEvent: 'PaymentWebhookEvent',
  DocReactionState: 'DocReactionState',
  DocOpinionEvent: 'DocOpinionEvent',
  ErrorNotificationLog: 'ErrorNotificationLog',
  QaCategory: 'QaCategory',
  QaQuestion: 'QaQuestion',
  QaAnswer: 'QaAnswer',
  QaComment: 'QaComment',
  QaVote: 'QaVote',
  QaExampleGroup: 'QaExampleGroup',
  QaExample: 'QaExample',
  QaRelatedQuestion: 'QaRelatedQuestion',
  OntConcept: 'OntConcept',
  OntAlias: 'OntAlias',
  OntEdge: 'OntEdge',
  QuestionConcept: 'QuestionConcept',
  EojeolBalance: 'EojeolBalance',
  EojeolTransaction: 'EojeolTransaction',
  AnonymousUsage: 'AnonymousUsage',
  DownloadLog: 'DownloadLog',
  SpellerReport: 'SpellerReport',
  SiteReview: 'SiteReview',
  PushSubscription: 'PushSubscription',
  NotificationPreference: 'NotificationPreference',
  PushDeliveryLog: 'PushDeliveryLog',
  PublicStatsSnapshot: 'PublicStatsSnapshot',
  ResearchApplication: 'ResearchApplication',
  AddonUserSetting: 'AddonUserSetting',
  AddonProfile: 'AddonProfile',
  AddonDailyStat: 'AddonDailyStat',
  NoticeMailDelivery: 'NoticeMailDelivery'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
